let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jr7Jf")).then(() => parcelRequire('I9Pmk'));